module.exports = __webpack_public_path__ + "img/8.88f48166.svg";